// 대량 AI 평가 발행(캠페인·프로젝트 일괄 요청)의 확인 흐름.
// 서버가 dry_run 으로 센 건수를 보여주고, 사용자가 확인한 그 건수(confirm_expected)로만 발행한다.
// 대상 수가 그사이 바뀌면 서버가 409 를 주고(본문은 평문) 아무것도 발행하지 않으므로,
// 다시 세어 바뀐 건수로 한 번 더 확인받는다.
// node:test 단위 테스트 + webpack 빌드 양쪽에서 쓰기 위해 CommonJS 로 작성한다.

function newIdempotencyKey() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    // ponytail: 비보안 컨텍스트(http://IP) 폴백. 중복 발행 방지용 키라 추측 불가능할 필요는 없다.
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

// dry_run 을 모르는 구 백엔드는 dry_run 을 무시하고 실제로 발행한다(2026-09-21 사고와 같은 모양).
// 응답이 dry_run 이 아니면 건수로 쓰지 않고 멈춘다.
function readDryRunExpected(data) {
    if (data?.dry_run !== true || !Number.isInteger(data?.expected) || data.expected < 0) {
        throw new Error('서버가 건수 미리보기(dry_run)에 응답하지 않았습니다.');
    }
    return data.expected;
}

// post: (payload) => Promise<data>   — 두 화면의 axios 호출(로딩 표시 포함)
// confirm: (expected, previousExpected|null) => Promise<boolean>
// 결과: {outcome: 'empty'} | {outcome: 'cancelled'} | {outcome: 'accepted', data}
async function runConfirmedDispatch({post, body, confirm}) {
    let previous = null;
    for (;;) {
        const expected = readDryRunExpected(await post({...body, dry_run: true}));
        if (expected === 0) return {outcome: 'empty'};
        if (!(await confirm(expected, previous))) return {outcome: 'cancelled'};
        try {
            // 확인 클릭 1회 = 새 키. 같은 확인의 재전송만 서버가 replay 로 막아준다.
            const data = await post({...body, confirm_expected: expected, idempotency_key: newIdempotencyKey()});
            return {outcome: 'accepted', data};
        } catch (e) {
            if (e?.response?.status !== 409) throw e;
            previous = expected;
        }
    }
}

module.exports = {runConfirmedDispatch, readDryRunExpected, newIdempotencyKey};
